var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopSmallWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12789_3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15.75H16.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.25V6C2.75 6.59674 2.98705 7.16903 3.40901 7.59099C3.83097 8.01295 4.40326 8.25 5 8.25C5.59674 8.25 6.16903 8.01295 6.59099 7.59099C7.01295 7.16903 7.25 6.59674 7.25 6M2.75 5.25H16.25M2.75 5.25L4.25 2.25H14.75L16.25 5.25M7.25 6V5.25M7.25 6C7.25 6.59674 7.48705 7.16903 7.90901 7.59099C8.33097 8.01295 8.90326 8.25 9.5 8.25C10.0967 8.25 10.669 8.01295 11.091 7.59099C11.5129 7.16903 11.75 6.59674 11.75 6M11.75 6V5.25M11.75 6C11.75 6.59674 11.9871 7.16903 12.409 7.59099C12.831 8.01295 13.4033 8.25 14 8.25C14.5967 8.25 15.169 8.01295 15.591 7.59099C16.0129 7.16903 16.25 6.59674 16.25 6V5.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.75V8.13745",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 15.75V8.13745",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 15.75V12.75C7.25 12.3522 7.40804 11.9706 7.68934 11.6893C7.97064 11.408 8.35218 11.25 8.75 11.25H10.25C10.6478 11.25 11.0294 11.408 11.3107 11.6893C11.592 11.9706 11.75 12.3522 11.75 12.75V15.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12789_3018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSmallWhite);
export default __webpack_public_path__ + "static/media/shop-small-white.2d965f94d21d8f802ac6fa844abae69d.svg";
export { ForwardRef as ReactComponent };